const emitAtomValue = async (opts) => {
    const { port, atomId, atom } = opts;
    const value = 'value' in opts ? opts.value : await atom.get();
    port.emit(atomId, value);
};
const attachAtom = ({ port, application, atom, atomId }) => {
    let loaded = false;
    application.on('load', async () => {
        loaded = true;
        await emitAtomValue({ port, atomId, atom });
    });
    atom.observe((value) => {
        if (loaded) {
            emitAtomValue({ port, atomId, atom, value });
        }
    });
};
const attachAtoms = ({ port, application, atoms }) => {
    for (const [atomId, atom] of Object.entries(atoms)) {
        attachAtom({ port, application, atom, atomId });
    }
};
export default attachAtoms;
